import loadable from '@loadable/component'

// 随堂练习
export default {
  '/w/quizmokao/quiz': loadable(() => import('./quiz_pc')),
  '/w/quizmokao/collectbook' : loadable(() => import('./CollectBook')), //收藏题目
  '/w/quizmokao/errorbook' : loadable(() => import('./ErrorBook')), //错题本
  '/w/quizmokao/notebook' : loadable(() => import('./NoteBook')), //笔记
  '/w/quizmokao/recordbook' : loadable(() => import('./RecordBook')), //做题记录
  '/w/quizmokao/myQuestion' : loadable(() => import('./MyQuestion')), //收藏题目详情
  '/w/quizmokao/history' : loadable(() => import('./AnswerAnalysis')), //做题记录
  '/w/quizmokao/newExam' : loadable(() => import('../doExercise/Home')),//新的出题页(继续练习/错题本/随堂练习)
  '/w/quizmokao/resultPage' : loadable(() => import('./NewExam/ResultPage')),//答题结束页
}
